import { PublicPlan } from '@wix/ambassador-pricing-plans-read-api/types';
import { IWixAPI } from '@wix/native-components-infra/dist/src/types/types';
import { ControllerFlowAPI } from 'yoshi-flow-editor-runtime/build/cjs/flow-api/ViewerScript';

import { OrdersApi, PlansApi } from '../../../services';
import { PricingPlansBi } from '../../../services/bi';
import { CheckoutData, StatusData, StatusProps } from '../../../types/common';
import { PackagePickerInteractions } from '../../../types/PackagePickerFedops';
import { getPageType } from '../../../utils/pageType';
import { Router } from './Router';

export class StatusController {
  constructor(
    protected setProps: (props: Partial<StatusProps>) => void,
    protected wixCodeApi: IWixAPI,
    protected ordersApi: OrdersApi,
    protected flowAPI: ControllerFlowAPI,
    protected bi: PricingPlansBi,
    protected router: Router,
    protected plansApi: PlansApi,
  ) {}

  public async initialize(statusData: StatusData) {
    return this.update(statusData);
  }

  public async update(statusData: StatusData, plan?: PublicPlan) {
    this.flowAPI.fedopsLogger.interactionStarted(PackagePickerInteractions.StatusPageLoaded);
    this.bi.membershipStatusLoaded(getPageType(statusData, statusData.purchaseData.checkoutData.integrationData));
    return this.setProps({
      successful: statusData.successful,
      translatedError: statusData.error,
      startDate: statusData.startDate,
      navigateBackToTPA: () => this.navigateBackToTPA(statusData),
      navigateBackToCheckout: () => this.navigateBackToCheckout(statusData.purchaseData.checkoutData, plan),
      biThankYouPageCtaButtonClick: () => this.bi.thankYouPageCtaButtonClick(),
    });
  }

  navigateBackToTPA = async ({ planName, startDate, purchaseData }: StatusData) => {
    const { navigateToPageProps, navigateToSectionProps } = purchaseData.checkoutData.integrationData;

    if (navigateToSectionProps) {
      if (startDate) {
        navigateToSectionProps.queryParams = {
          ...(navigateToSectionProps.queryParams ?? {}),
          startDate,
          planName,
        };
      }

      const { queryParams, state, ...sectionProps } = navigateToSectionProps;
      const { relativeUrl } = await this.wixCodeApi.site.getSectionUrl(sectionProps);

      let url = relativeUrl + '';
      if (state) {
        url += '/' + state;
      }
      if (queryParams) {
        url += '?appSectionParams=' + encodeURIComponent(JSON.stringify(queryParams));
      }
      this.wixCodeApi.location.to!(url);
    } else if (navigateToPageProps) {
      this.wixCodeApi.location.navigateTo?.({ pageId: navigateToPageProps });
    }
  };

  navigateBackToCheckout = async ({ integrationData, planId }: CheckoutData, plan?: PublicPlan) => {
    let plans: PublicPlan[] = [];
    if (plan) {
      plans = [plan];
    } else {
      try {
        plans = await this.plansApi.loadPaidPlans({ planIds: [planId] });
      } catch {}
    }
    if (plans.length > 0) {
      this.router.gotoCheckout(plans[0], integrationData);
    } else {
      this.router.gotoHomePage();
    }
  };
}
